<div class="box-container shadow-box" [@fadeInOut]="'in'">
  @if (!done) {
    <div>
      @if (!!currentQuestion) {
        <app-question [question]="currentQuestion" [sendingResults]="sendingResults" (onAnswer)="triggerNext($event)"></app-question>
      }
      <!-- Ending questionnaire -->
      @if (!identification && currentQuestion == null) {
        <div class="sending-results">
          Enviando resultados...
          <br/>
          <fa-icon [icon]="faSpinner" [spin]="true"></fa-icon>
        </div>
      }
    </div>
  }
  @if (!done && identification) {
    <div class="done">
      <div>Gostaria de se identificar?</div>
      <br/>
      <div>
        <input type="text" class="text-area-question" [(ngModel)]="customer.name" placeholder="Nome:" />
        <br/>
        <input type="text" class="text-area-question" [(ngModel)]="customer.phone" mask="(00) 0 0000-0000" placeholder="Fone:" />
        <br/>
        <input type="email" class="text-area-question" [(ngModel)]="customer.email" placeholder="E-mail:" />
        <br/>
        <div class="send-button">
          @if (!sendingAll) {
            <button (click)="fetchResults()">ENVIAR</button>
          }
        </div>
      </div>
    </div>
  }
  @if (done) {
    <div class="done">
      <div>Obrigado por responder nosso questionário!</div>
      <div>Com sua avaliação, estamos 1 passo mais perto de oferecer o atendimento ideal para você</div>
    </div>
  }
</div>
